import React, { Component } from 'react';

import EditableListButtons from 'src/features/Positions/containers/EditableListButtons';
import EditableListFormed from 'src/features/Positions/containers/EditableListFormed';

export default class Positions extends Component {
  render() {
    return (
      <div>
        <EditableListButtons />
        <EditableListFormed type="Position" />
      </div>
    );
  }
}
